import { BatteryVersion } from '@shared/models/business/battery-version.model';
import { ModelEnergy } from '@shared/models/business/model-energy.model';
import { EnergySubtype } from '../../vehicleCost/impactCo2/energy-subtype.model';

export class EnergyConfig {
	model: ModelEnergy;
	payload: number;
	battery?: BatteryVersion;
	energySubtype?: EnergySubtype;
	electricTruckBatteryWarningTranslationKey?: string;
}
